import React from "react";
import data from '../assets/about/iit-jee.png'
function CourseEnquiry() {
  return (
    <div className="bg-[#20b2aa] py-12 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Left Section */}
        <div className="text-center lg:text-left space-y-6">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 leading-snug">
            Latest Java Courses <br /> for Engineering Students
          </h2>
          <p className="text-lg text-gray-700 font-medium">
            IIT-JEE | NEET | EPCET | SHORT TERM 
          </p>

          <div className="relative flex justify-center lg:justify-start">
            {/* Main image */}
            <div className="relative">
              <img
                src={data}
                alt="Java Course"
                className="rounded-2xl shadow-lg w-full max-w-md mx-auto"
              />

              {/* Floating Badges */}
              <div className="absolute -top-6 -right-6 bg-white px-3 py-2 rounded-md shadow-md text-sm font-semibold text-green-600">
                ✅ 100% Student Satisfaction
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white px-3 py-2 rounded-md shadow-md text-sm font-semibold text-blue-600">
                📊 12,750+ Courses Completed
              </div>
              <div className="absolute -bottom-6 right-6 bg-white px-3 py-2 rounded-md shadow-md text-sm font-semibold text-cyan-600">
                ⏰ On-Time Delivery
              </div>
            </div>
          </div>
        </div>

        {/* Right Section (Form) */}
        <div className="bg-white rounded-xl shadow-lg p-8 w-full">
          <h3 className="text-xl font-semibold text-gray-900 mb-6 text-center">
            Get Help With Your  
          </h3>

          <form className="space-y-4">
            <input
              type="text"
              placeholder="Your Name"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="tel"
              placeholder="Your Phone Number"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="email"
              placeholder="Your E-Mail ID"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="text"
              placeholder="Your Course"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />

            <button
              type="submit"
              className="w-full bg-[#20b2aa] hover:bg-white hover:text-[#20b2aa] hover:border hover:border-[#20b2aa] text-white font-semibold rounded-lg py-3 transition duration-200"
            >
              Enquire Now
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CourseEnquiry;
